

export const SET_MARINAS = 'SET_MARINAS'
export const SET_FINISH_MARINAS = 'SET_FINISH_MARINAS'
export const SET_YACHT_MODELS = 'SET_YACHT_MODELS'
export const SET_SHIPYARDS = 'SET_SHIPYARDS'
export const SET_YACHT_TYPES = 'SET_YACHT_TYPES'
export const SET_YACHTS = 'SET_YACHTS'
export const SET_REGIONS = 'SET_REGIONS'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_FINISH_COUNTRIES = 'SET_FINISH_COUNTRIES'
export const SET_CITIES = 'SET_CITIES'
export const SET_CREW_ROLES = 'SET_CREW_ROLES'
export const SET_OPERATORS = 'SET_OPERATORS'
export const SET_LICENSE_SYSTEMS = 'SET_LICENSE_SYSTEMS'
export const SET_LICENSE_TYPES = 'SET_LICENSE_TYPES'

// types of data
export const MARINAS = 'marinas'
export const FINISH_MARINAS = 'MARINAS'
export const YACHT_MODELS = 'yacht-models'
export const SHIPYARDS = 'shipyards'
export const YACHT_TYPES = 'yacht-types'
export const YACHTS = 'yachts'
export const REGIONS = 'regions'
export const COUNTRIES = 'countries'
export const FINISH_COUNTRIES = 'COUNTRIES'
export const CITIES = 'cities'
export const CREW_ROLES = 'crew-roles'
export const OPERATORS = 'operators'
export const LICENSE_SYSTEMS = 'license-systems'
export const LICENSE_TYPES = 'license-types'
